import { useState } from "react";
import { Link } from "react-router-dom";
import { useAdmin } from "../context/adminContext";
import { Menu, X, ShoppingBag } from "lucide-react";

function Navbar() {
  const { admin } = useAdmin();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="mb-16" role="banner">
      <nav
        className="bg-white shadow-md text-gray-800 px-6 py-4 fixed top-0 left-0 w-full z-50"
        aria-label="Main navigation"
      >
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          {/* Logo + Brand */}
          <div className="flex items-center space-x-3">
            <Link to="/" className="flex items-center space-x-2">
              <img
                src="/logo.png" 
                alt="Shakshi Collection Logo"
                className="w-14 h-14 object-contain rounded-full"
                loading="lazy"
              />
              <div className="text-left leading-tight">
                <span className="block font-bold text-lg">
                  Shakshi Collection
                </span>
                <span className="block text-xs opacity-90">
                  Kaij, Maharashtra
                </span>
              </div>
            </Link>
          </div>

          {/* Desktop Links */}
          <div
            className="hidden md:flex space-x-8 items-center"
            role="navigation"
          >
            <NavLink to="/" label="Home" />
            <NavLink to="/collections" label="Collections" />
            <NavLink to="/women" label="Women" />
            <NavLink to="/men" label="Men" />
            <NavLink to="/kids" label="Kids" />
            <NavLink to="/contact" label="Contact" />

            {/* Admin Shortcut */}
            {admin && (
              <Link
                to="/dashboard"
                className="text-sm bg-gray-100 hover:bg-gray-200 px-3 py-1 rounded flex items-center space-x-1"
              >
                <ShoppingBag size={16} />
                <span>Admin Dashboard</span>
              </Link>
            )}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsOpen(!isOpen)}
              aria-label={isOpen ? "Close menu" : "Open menu"}
              aria-expanded={isOpen}
              aria-controls="mobile-menu"
            >
              {isOpen ? <X size={26} /> : <Menu size={26} />}
            </button>
          </div>
        </div>

        {/* Mobile Dropdown */}
        {isOpen && (
          <div
            id="mobile-menu"
            className="md:hidden mt-2 px-4 pb-3 space-y-2 bg-white rounded-b shadow"
            role="menu"
            aria-label="Mobile navigation menu"
          >
            <MobileNavLink to="/" label="Home" setIsOpen={setIsOpen} />
            <MobileNavLink
              to="/collections"
              label="Collections"
              setIsOpen={setIsOpen}
            />
            <MobileNavLink to="/women" label="Women" setIsOpen={setIsOpen} />
            <MobileNavLink to="/men" label="Men" setIsOpen={setIsOpen} />
            <MobileNavLink to="/kids" label="Kids" setIsOpen={setIsOpen} />
            <MobileNavLink
              to="/contact"
              label="Contact"
              setIsOpen={setIsOpen}
            />
            {admin && (
              <Link
                to="/dashboard"
                onClick={() => setIsOpen(false)}
                className="block w-full text-left mt-2 bg-gray-100 hover:bg-gray-200 px-3 py-2 rounded text-sm"
                role="menuitem"
              >
                Admin Dashboard
              </Link>
            )}
          </div>
        )}
      </nav>
    </header>
  );
}

function NavLink({ to, label }) {
  return (
    <Link
      to={to}
      className="hover:text-[#8f5734] text-sm font-medium tracking-wide"
    >
      {label}
    </Link>
  );
}

function MobileNavLink({ to, label, setIsOpen }) {
  return (
    <Link
      to={to}
      onClick={() => setIsOpen(false)}
      className="block hover:text-[#8f5734] text-sm font-medium"
      role="menuitem"
    >
      {label}
    </Link>
  );
}

export default Navbar;
